import { Expandable } from '@bob/library'
import { mapExpandableSpot } from '@websrc/DataMappers/mapSpot'
import { SpotContent } from '@websrc/Spot/Content/SpotContent'
import { SpotIconExplainer } from '@websrc/Spot/IconExplainer/SpotIconExplainer'
import { SpotSegmentSelector } from '@websrc/Spot/SegmentSelector/SpotSegmentSelector'
import React from 'react'
import { match } from 'ts-pattern'

import * as SC from './SpotExpandable.style'

export type SpotExpandableProps = ReturnType<typeof mapExpandableSpot>

export const SpotExpandable = ({ spots, titles }: SpotExpandableProps) => (
  <SC.Wrapper>
    <Expandable bottomOffset={100} titles={titles} topOffset={100}>
      {spots.map((spot, key) =>
        match(spot)
          .with({ __dataType: 'iconExplainer' }, ({ icon_explainer }) => (
            <SpotIconExplainer
              key={key}
              renderAsCarousel={false}
              spot={icon_explainer}
              withinExpandable={true}
            />
          ))
          .with({ __dataType: 'contentSpot' }, ({ content_spot }) => (
            <SpotContent imageLazy={false} key={key} spot={content_spot} withinExpandable={true} />
          ))
          .with({ __dataType: 'segmentSelector' }, ({ segment_selector }) => (
            <SpotSegmentSelector
              imageLazy={false}
              key={key}
              spot={segment_selector}
              withinExpandable={true}
            />
          ))
          .otherwise(() => null)
      )}
    </Expandable>
  </SC.Wrapper>
)
